if (document.querySelector('.hero')) {

    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const progress=document.querySelector('.progress');const heroVideo=document.querySelector('.hero-media');const product=document.querySelector('.product-img');const story=document.querySelector('.product-story');const copies=[...document.querySelectorAll('.story-copy')];const rail=document.querySelector('.gallery-rail');
    // Viewport reveals with stagger-ready CSS transitions.
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.14});document.querySelectorAll('.reveal,.reveal-clip').forEach(el=>io.observe(el));
    // One requestAnimationFrame loop coordinates progress, parallax, sticky storytelling and gallery movement.
    let busy=false;function paint(){const y=scrollY;const max=document.documentElement.scrollHeight-innerHeight;progress.style.transform=`scaleX(${y/max})`;if(!reduced){heroVideo.style.transform=`translateY(${Math.min(y*.12,100)}px) scale(1.04)`;document.querySelectorAll('[data-parallax]').forEach(img=>{const r=img.parentElement.getBoundingClientRect();img.style.transform=`translateY(${(r.top-innerHeight/2)*-.035}px)`});const sr=story.getBoundingClientRect();const p=Math.max(0,Math.min(1,-sr.top/(story.offsetHeight-innerHeight)));const scale=.72+p*.34;product.style.transform=`translate(-50%,-50%) scale(${scale}) rotate(${(p-.5)*1.4}deg)`;product.style.filter=`drop-shadow(0 45px 70px rgba(0,0,0,.8)) saturate(${.75+p*.5})`;copies.forEach((c,i)=>c.classList.toggle('active',p>i*.27+.12&&p<i*.27+.46));const gr=document.querySelector('.gallery-section').getBoundingClientRect();const travel=Math.max(0,rail.scrollWidth-innerWidth);const gp=Math.max(0,Math.min(1,(innerHeight-gr.top)/(gr.height+innerHeight)));rail.style.transform=`translateX(${-travel*gp}px)`}busy=false}addEventListener('scroll',()=>{if(!busy){requestAnimationFrame(paint);busy=true}},{passive:true});paint();
    // Video sound toggle.
    document.querySelector('.sound').addEventListener('click',e=>{heroVideo.muted=!heroVideo.muted;e.currentTarget.textContent=heroVideo.muted?'⌁':'◉';e.currentTarget.setAttribute('aria-label',heroVideo.muted?'Turn video sound on':'Mute video')});
    // Accessible accordion with a single open answer.
    document.querySelectorAll('.faq-q').forEach(btn=>btn.addEventListener('click',()=>{const item=btn.parentElement;const open=!item.classList.contains('open');document.querySelectorAll('.faq-item').forEach(x=>{x.classList.remove('open');x.querySelector('button').setAttribute('aria-expanded','false')});if(open){item.classList.add('open');btn.setAttribute('aria-expanded','true')}}));
  
}

(() => {
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100) + ' ' + currency; }
    catch (_) { return '$' + (cents / 100).toFixed(2) + ' ' + currency; }
  };

  /* ---------- Product page ---------- */
  const productForm = document.querySelector('.shopify-product-form');
  if (productForm) {
    const quantity = productForm.querySelector('#Quantity');
    const pricePanel = document.querySelector('[data-product-price]');
    const priceTotal = document.querySelector('[data-price-total]');
    const compareTotal = document.querySelector('[data-compare-total]');
    const buttonTotal = document.querySelector('[data-button-total]');
    const submit = productForm.querySelector('[type="submit"]');
    const buttonLabel = submit.querySelector('span');
    const error = productForm.querySelector('[data-form-error]');
    const currency = pricePanel.dataset.currency || 'AUD';
    const IDLE_LABEL = 'Add to bag';

    const refresh = () => {
      const variant = productForm.querySelector('input[name="id"]:checked');
      const count = Math.max(1, Math.min(10, Number.parseInt(quantity.value, 10) || 1));
      const unitPrice = Number(variant.dataset.price);
      const comparePrice = Number(variant.dataset.comparePrice || unitPrice);
      quantity.value = count;
      priceTotal.textContent = money(unitPrice * count, currency);
      if (compareTotal) { compareTotal.textContent = money(comparePrice * count, currency); compareTotal.hidden = comparePrice <= unitPrice; }
      if (buttonTotal) buttonTotal.textContent = money(unitPrice * count, currency);
      pricePanel.classList.remove('price-bump'); requestAnimationFrame(() => pricePanel.classList.add('price-bump'));
    };

    // Restore the button to its idle state. Also runs on bfcache restore, so
    // pressing Back from checkout never leaves a stuck "Adding to bag..." label.
    const resetSubmit = () => {
      submit.disabled = false;
      if (buttonLabel) buttonLabel.textContent = IDLE_LABEL;
      if (buttonTotal) buttonTotal.hidden = false;
      error.textContent = '';
      refresh();
    };

    productForm.querySelector('[data-qty-minus]').addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); refresh(); });
    productForm.querySelector('[data-qty-plus]').addEventListener('click', () => { quantity.value = Math.min(10, Number(quantity.value || 1) + 1); refresh(); });
    quantity.addEventListener('input', refresh); quantity.addEventListener('change', refresh);
    productForm.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', refresh));

    productForm.addEventListener('submit', async event => {
      event.preventDefault();
      error.textContent = ''; submit.disabled = true;
      if (buttonLabel) buttonLabel.textContent = 'Adding to bag…';
      if (buttonTotal) buttonTotal.hidden = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
        if (!response.ok) throw new Error('cart_error');
        location.href = '/cart';
      } catch (_) {
        error.textContent = 'We could not add that to your bag. Please try again.';
        resetSubmit();
      }
    });

    window.addEventListener('pageshow', resetSubmit);
    refresh();
  }

  /* ---------- Bag ---------- */
  const cartItems = document.querySelector('.shopify-cart__items');
  if (cartItems) {
    const busy = document.querySelector('[data-bag-busy]');
    const controls = () => cartItems.querySelectorAll('input, select, button');
    const setBusy = on => {
      if (busy) busy.hidden = !on;
      cartItems.style.opacity = on ? '0.5' : '';
      controls().forEach(el => { el.disabled = on; });
    };
    const post = (url, body) => fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });

    // Quantity change, or removal when quantity is 0.
    const changeLine = async (line, qty) => {
      setBusy(true);
      try {
        const r = await post('/cart/change.js', { line, quantity: qty });
        if (!r.ok) throw new Error('change_failed');
        location.reload();
      } catch (_) { setBusy(false); }
    };

    // Shopify has no "change the variant on this line" call, so drop the line
    // and re-add the chosen variant at the same quantity.
    const swapVariant = async (line, newId, qty) => {
      setBusy(true);
      try {
        let r = await post('/cart/change.js', { line, quantity: 0 });
        if (!r.ok) throw new Error('remove_failed');
        r = await post('/cart/add.js', { id: Number(newId), quantity: qty });
        if (!r.ok) throw new Error('add_failed');
        location.reload();
      } catch (_) { setBusy(false); location.reload(); }
    };

    cartItems.querySelectorAll('[data-cart-quantity]').forEach(input => {
      const line = Number(input.dataset.line);
      const article = input.closest('article');
      article.querySelector('[data-line-minus]').addEventListener('click', () => {
        const n = Math.max(1, Number(input.value || 1) - 1); input.value = n; changeLine(line, n);
      });
      article.querySelector('[data-line-plus]').addEventListener('click', () => {
        const n = Math.min(10, Number(input.value || 1) + 1); input.value = n; changeLine(line, n);
      });
      input.addEventListener('change', () => {
        const n = Math.max(1, Math.min(10, Number.parseInt(input.value, 10) || 1)); input.value = n; changeLine(line, n);
      });
    });

    cartItems.querySelectorAll('[data-line-variant]').forEach(select => {
      select.addEventListener('change', () => {
        const article = select.closest('article');
        const qty = Math.max(1, Number(article.querySelector('[data-cart-quantity]').value) || 1);
        swapVariant(Number(select.dataset.line), select.value, qty);
      });
    });

    cartItems.querySelectorAll('[data-line-remove]').forEach(button => {
      button.addEventListener('click', () => changeLine(Number(button.dataset.line), 0));
    });
  }
})();